import Axios from 'api/client';
import { AxiosRequestConfig, Method } from 'axios';
import { Export } from 'types/domain';
import { FilterParams } from 'types/params';

interface GenerateExportsHistoryParams extends FilterParams {
    object?: string;
    object_id?: number;
    report_type?: string;
    resource?: string;
    template?: string | null;
    search?: string;
    year?: string;
    type?: string;
    group?: boolean;
    headings?: string[];
    archived?: boolean;
}

interface PatchExportData {
    is_shareable?: boolean;
}

const generateExportsFactory = (httpMethod: Method) => {
    return (accountId: number, params: GenerateExportsHistoryParams = {}) => {
        const normalizedParams: AxiosRequestConfig = {};
        if (httpMethod === 'GET') {
            normalizedParams.params = params;
        } else {
            normalizedParams.data = params;
        }
        return Axios.request({
            url: `/accounts/${accountId}/exports`,
            method: httpMethod,
            ...normalizedParams,
        }).then(response => response.data);
    };
};

const generateExports = generateExportsFactory('POST');

const fetchExportHistory = generateExportsFactory('GET');

const deleteExport = (accountId: number, exportId: number) => {
    return Axios.delete(`/accounts/${accountId}/exports/${exportId}`);
};

const patchExport = (accountId: number, exportId: number, data?: PatchExportData) => {
    return Axios.patch<Export>(`/accounts/${accountId}/exports/${exportId}`, data || {}).then(
        response => response.data,
    );
};

export { generateExports, deleteExport, patchExport, fetchExportHistory };
export type { GenerateExportsHistoryParams };
